import { render, staticRenderFns } from "./ProFactures.vue?vue&type=template&id=012a42a1&"
import script from "./ProFactures.vue?vue&type=script&lang=js&"
export * from "./ProFactures.vue?vue&type=script&lang=js&"
import style0 from "./ProFactures.vue?vue&type=style&index=0&id=012a42a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports